<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label>源文件名</label>
                </div>
                <div class="form-value" :title="shopDeviceImpRec.fileName">
                    <span>{{shopDeviceImpRec.fileName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>导入人</label>
                </div>
                <div class="form-value">
                    <span>{{shopDeviceImpRec.importerName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>来源单据类型</label>
                </div>
                <div class="form-value">
                    <span>{{devcVoucherTypeEnumMap[shopDeviceImpRec.srcVoucherType]}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>来源单据编号</label>
                </div>
                <div class="form-value">
                    <span>{{shopDeviceImpRec.srcVoucherNo}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>导入时间</label>
                </div>
                <div class="form-value">
                    <span>{{shopDeviceImpRec.importTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>成功条数</label>
                </div>
                <div class="form-value">
                    <span style="color: green">{{shopDeviceImpRec.okCount}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>失败条数</label>
                </div>
                <div class="form-value">
                    <span v-if="shopDeviceImpRec.errorCount != 0" style="color: red">{{shopDeviceImpRec.errorCount}}</span>
                    <span v-else>{{shopDeviceImpRec.errorCount}}</span>
                </div>
            </div>
        </div>
        <div class="table-layout" style="overflow-x: auto;height: 580px;">
            <table class="custom-tbl">
                <thead class="head">
                <tr class="row">
                    <th width="70" class="align-right" style="padding-right:8px;">源件行号</th>
                    <th class="align-left" width="100">批次号</th>
                    <th width="60">关联定义</th>
                    <th class="align-left" width="100">外部系统编号</th>
                    <th class="align-left" width="100">统一商品代码(UPC)</th>
                    <th class="align-left" width="250">耗材名称</th>
                    <th class="align-left" width="250">所属机构</th>
                    <th class="align-left" width="140">分类</th>
                    <th class="align-left" width="140">品牌</th>
                    <th class="align-left" width="250">规格</th>
                    <th class="align-right" width="50" style="padding-right:8px;">数量</th>
                    <th class="align-left" width="100">单位</th>
                    <th width="70">入账方式</th>
                    <th class="align-left" width="70">责任部门</th>
                    <th class="align-left" width="70">责任人</th>
                    <th class="align-left" width="100">备注</th>
                    <th width="60">结果</th>
                    <th class="align-left" width="100">失败描述</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr class="row" v-for="shopStuffImpItem in shopStuffImpItemList">
                    <td class="align-right" style="padding-right:8px;color:#999;">{{shopStuffImpItem.rowNo}}</td>
                    <td class="align-left">{{shopStuffImpItem.batchNo}}</td>
                    <td><span style="font-size: 20px">{{shopStuffImpItem.devcDefId != -1 ? '√' : ''}}</span></td>
                    <td class="align-left">{{shopStuffImpItem.innerNo}}</td>
                    <td class="align-left">{{shopStuffImpItem.upn}}</td>
                    <td class="align-left">{{shopStuffImpItem.stuffName}}</td>
                    <td class="align-left">{{shopStuffImpItem.shopName}}</td>
                    <td class="align-left">{{shopStuffImpItem.catName}}</td>
                    <td class="align-left">{{shopStuffImpItem.brandName}}</td>
                    <td class="align-left">{{shopStuffImpItem.modelSpec}}</td>
                    <td class="align-right" style="padding-right:8px;">{{shopStuffImpItem.quantity}}</td>
                    <td class="align-left">{{shopStuffImpItem.theUnit}}</td>
                    <td>{{acctEnterWayMap[shopStuffImpItem.acctEnterWay]}}</td>
                    <td class="align-left">{{shopStuffImpItem.departName}}</td>
                    <td class="align-left">{{shopStuffImpItem.principalName}}</td>
                    <td class="align-left">{{shopStuffImpItem.memo}}</td>
                    <td>
                        <span v-if="shopStuffImpItem.failed" style="color: red;font-size: 20px">×</span>
                        <span v-else style="color: green;font-size: 20px">√</span>
                    </td>
                    <td class="align-left">{{shopStuffImpItem.failDesc}}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="pagination-layout">
            <el-pagination background v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../../src/app.conf'
    import { checkUserActionPerm } from '../index'

    import shopStuffApi from '../../api/shopStuff'

    export default {
        name: 'swb-shop-device-imp-item-lowCost-list',
        desc: '机构设备导入记录详细列表',
        props: ['recId', 'selfThis'],
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },

                shopDeviceImpRec: {},
                shopStuffImpItemList: [],
                acctEnterWayMap: getEnumMap('acctEnterWay', 'value2text'),
                deviceUseStateMap: getEnumMap('deviceUseState', 'value2text'),
                devcVoucherTypeEnumMap: getEnumMap("devcVoucherType", "value2text")
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getShopStuffImpRecById(this.recId);
        },
        methods: {
            checkActionPerm(action) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, null);
            },
            getShopStuffImpRecById: function (recId) {
                let self = this;
                shopStuffApi.getShopStuffImpRecById(recId, function (result) {
                    if(result.type == 'info') {
                        self.shopDeviceImpRec = result.data;
                        self.getShopDeviceImpItemPageListByFilter();
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getShopDeviceImpItemPageListByFilter();
            },
            getShopDeviceImpItemPageListByFilter(){
                let self = this;
                let shopDeviceImpRec = this.shopDeviceImpRec;
                //
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.recId = shopDeviceImpRec.id;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                shopStuffApi.getShopStuffImpItemPageListByFilter(postData, function (result) {
                    if(result.type == 'info') {
                        self.shopStuffImpItemList = result.data.rows;
                        self.totalCount = result.data.pagination.totalCount;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/ShopDeviceLowCost/ShopDeviceImpItemLowCostList.vue